// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"312":"56f08170","912":"4251dcf1"}[chunkId] + ".chunk.css";
};